var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.69131 0H18.3087C21.452 0 24 2.54799 24 5.6913V18.3087C24 21.452 21.452 24 18.3087 24H5.69131C2.548 24 0 21.452 0 18.3087V5.6913C0 2.54799 2.548 0 5.69131 0Z",
    fill: "#121D39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3472 0.648682H8.64453C4.22625 0.648682 0.644531 4.2304 0.644531 8.64868V15.3514C0.644531 19.7697 4.22625 23.3514 8.64453 23.3514H15.3472C19.7655 23.3514 23.3472 19.7697 23.3472 15.3514V8.64868C23.3472 4.2304 19.7655 0.648682 15.3472 0.648682Z",
    fill: "#121D39"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4397 17.1775L13.1799 10.9889L12.6983 10.2889L9.65112 5.86199L9.39855 5.49512H5.6543L6.56751 6.82218L10.6191 12.709L11.1007 13.4082L14.3561 18.1381L14.6087 18.5047H18.353L17.4397 17.1775ZM15.0537 17.6575L11.6716 12.7436L11.19 12.0441L7.26551 6.34209H8.95366L12.1275 10.9534L12.6091 11.6529L16.7419 17.6575H15.0537Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.19 12.0442L11.6716 12.7437L11.1006 13.4082L6.71992 18.5045H5.63965L10.619 12.709L11.19 12.0442Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9017 5.49512L13.1795 10.9889L12.6086 11.6529L12.127 10.9534L12.6979 10.2889L15.8967 6.56576L16.8215 5.49512H17.9017Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXContact);
export default __webpack_public_path__ + "static/media/x-contact.f01455842d0f0fc3c5530169f488f3d3.svg";
export { ForwardRef as ReactComponent };